import React from "react";
import { Files } from "lucide-react";

import { TabSwitcher } from "components/ui/TabSwitcher";
import { isDeaspDocumentType } from "features/documents/utils/deaspDocumentType";
import { formatDocumentTypeLabel,getDocumentTypeIcon } from "utils/documentTypeIcons";

import styles from "./DocumentTypeMenu.module.css";

const ALL_OPTION = {
  value: "ALL",
  label: "All Documents",
  icon: <Files size={16} />,
};

export const DocumentTypeMenu = ({ selectedType, onTypeChange, documentTypes = [], _isLoading }) => {
  const options = [
    ALL_OPTION,
    ...documentTypes.filter((dt) => !isDeaspDocumentType(dt)).map((dt) => {
      const Icon = getDocumentTypeIcon(dt.name, dt.icon);
      return {
        value: dt.name,
        label: dt.label || formatDocumentTypeLabel(dt.name),
        icon: <Icon size={16} />,
      };
    }),
  ];

  return (
    <div className={styles.wrapper}>
      <TabSwitcher
        options={options}
        value={selectedType}
        onChange={onTypeChange}
        withOverflow
        fullWidth
      />
    </div>
  );
};
